<template>
  <b-modal
    :id="modalId"
    ref="modal"
    size="lg"
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    @hidden="fechar"
    @show="aoAbrir"
    centered
  >
    <!-- Cabeçalho Premium -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-warning" 
         style="background: linear-gradient(135deg, #f0ad4e 0%, #ec971f 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-pencil text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Carta de Correção Eletrônica (CC-e)</h5>
        <small class="text-white opacity-75">Corrija erros em campos específicos da NF-e</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div>

    <div class="p-4" v-if="nfe">
      <!-- Barra de Informações -->
      <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
        <b-row align-v="center">
          <b-col md="6">
            <small class="modal-label-premium">Destinatário</small>
            <h5 class="mb-0 font-weight-bold text-dark">{{ nfe.TX_NOME_CLIENTE || nfe.NOME_CLIENTE || 'Não informado' }}</h5>
          </b-col>
          <b-col md="3" class="border-left">
            <small class="modal-label-premium">NF-e / Série</small>
            <h5 class="mb-0 font-weight-bold text-primary">{{ nfe.TX_NUM_NFE || '---' }} / {{ nfe.ID_SERIE || '-' }}</h5>
          </b-col>
          <b-col md="3" class="border-left text-right">
            <small class="modal-label-premium">Valor Total</small>
            <h5 class="mb-0 font-weight-bold text-warning">{{ formatCurrency(nfe.VL_TOTAL_NFE) }}</h5>
          </b-col>
        </b-row>
      </div>

      <!-- Informações da NFe -->
      <b-alert show variant="warning" class="mb-4 border-0 shadow-sm rounded-lg">
        <div class="d-flex align-items-center mb-2">
          <i class="fa fa-exclamation-triangle mr-2"></i>
          <h6 class="mb-0 font-weight-bold">Condições de Uso da Carta de Correção</h6>
        </div>
        <p class="mb-2 small opacity-8">
          A Carta de Correção pode ser utilizada para regularização de erro ocorrido na emissão de documento fiscal, desde que o erro não esteja relacionado com:
        </p>
        <ul class="mb-0 small opacity-8">
          <li>Variáveis que determinam o valor do imposto (base de cálculo, alíquota, preço, quantidade, valor da operação);</li>
          <li>Correção de dados cadastrais que implique mudança do remetente ou do destinatário;</li>
          <li>Data de emissão ou de saída.</li>
        </ul>
      </b-alert>

      <b-form @submit.prevent="confirmarEnvio">
        <div class="modal-section-title mb-3">
          <i class="fa fa-commenting-o mr-2 text-warning"></i> Texto da Correção
        </div>
        
        <b-form-group 
          label-for="textarea-narrativa"
          description="Obs: A Justificativa deve ter no mínimo 15 e no máximo 1000 caracteres"
        >
          <b-form-textarea
            id="textarea-narrativa"
            v-model="narrativa"
            placeholder="Descreva detalhadamente a correção a ser feita neste documento..."
            rows="6"
            max-rows="10"
            :state="narrativaValida"
            required
            class="rounded-lg shadow-xs border-0 bg-light p-3"
          />
          <b-form-invalid-feedback :state="narrativaValida">
            A narrativa deve ter entre 15 e 1000 caracteres
          </b-form-invalid-feedback>
          <div class="d-flex justify-content-end mt-1">
            <small class="text-muted font-weight-bold">
              {{ narrativa.length }} / 1000 caracteres
            </small>
          </div>
        </b-form-group>

        <!-- Rodapé Premium -->
        <div class="modal-footer-premium p-3 bg-light d-flex justify-content-end border-top mx-n4 mb-n4 mt-4">
          <b-button variant="light" @click="fechar" class="mr-2 rounded-pill px-4 shadow-sm font-weight-bold">
            <i class="fa fa-times mr-1"></i> Cancelar
          </b-button>
          <b-button 
            variant="warning" 
            type="submit"
            :disabled="!narrativaValida || processando"
            class="rounded-pill px-4 shadow-sm text-white font-weight-bold"
          >
            <b-spinner small v-if="processando" class="mr-1" />
            <i class="fa fa-paper-plane mr-1" v-else></i> Enviar Carta
          </b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import Tools from '@/tools/tools.js'
export default {
  name: 'CartaCorrecaoModal',
  
  props: {
    modalId: {
      type: String,
      default: 'modal-carta-correcao'
    }
  },

  data() {
    return {
      nfe: null,
      narrativa: '',
      processando: false
    }
  },

  computed: {
    narrativaValida() {
      if (!this.narrativa) return null
      const tamanho = this.narrativa.trim().length
      return tamanho >= 15 && tamanho <= 1000
    }
  },

  methods: {
    abrir(nfe) {
      this.nfe = nfe
      this.$bvModal.show(this.modalId)
    },

    aoAbrir() {
      this.narrativa = ''
      this.processando = false
    },

    fechar() {
      this.$bvModal.hide(this.modalId)
      this.nfe = null
      this.narrativa = ''
      this.processando = false
    },

    confirmarEnvio() {
      if (!this.narrativaValida) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'A narrativa deve ter entre 15 e 1000 caracteres')
        return
      }

      this.$bvModal.msgBoxConfirm(
        'Deseja realmente enviar a Carta de Correção para esta NF-e?',
        {
          title: 'Confirmação',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'Sim, Enviar',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
      .then(confirmado => {
        if (confirmado) {
          this.enviarCarta()
        }
      })
      .catch(err => {
        console.error('Erro no modal de confirmação:', err)
      })
    },

    async enviarCarta() {
      if (!this.nfe || !this.nfe.ID) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'NF-e inválida')
        return
      }

      this.processando = true
      
      try {
        const payload = {
          nfeId: this.nfe.ID,
          numNfe: this.nfe.TX_NUM_NFE || this.nfe.ID,
          textoCartaCorrecao: this.narrativa.trim(),
          usuario: window.localStorage.getItem('login') || 'sistema'
        }

        const response = await this.$http.post('/api/protected/notaFiscal/enviarCarta/', payload)
        
        const resultado = response.data

        if (resultado && resultado.sucesso) {
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Carta de Correção enviada com sucesso')
          
          // Abrir PDF da Carta de Correção se disponível
          if (resultado.pdfBase64) {
            try {
              // Converte base64 para blob
              const byteCharacters = atob(resultado.pdfBase64)
              const byteNumbers = new Array(byteCharacters.length)
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
              }
              const byteArray = new Uint8Array(byteNumbers)
              const blob = new Blob([byteArray], { type: 'application/pdf' })

              // Cria a URL e abre o PDF
              const url = window.URL.createObjectURL(blob)
              window.open(url)
            } catch (errPdf) {
              console.error('Erro ao abrir PDF da Carta de Correção:', errPdf)
            }
          }
          
          this.$emit('carta-enviada', { nfeId: this.nfe.ID, resultado })
          this.fechar()
        } else {
          const erro = resultado?.erro || resultado?.mensagem || 'Erro ao enviar Carta de Correção'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
        }

      } catch (err) {
        console.error('Erro ao enviar Carta de Correção:', err)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err)
      } finally {
        this.processando = false
      }
    },

    formatCurrency(val) {
      return Tools.formatCurrency(val)
    }
  }
}
</script>

<style scoped>
.small {
  font-size: 0.875rem;
}
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/CartaCorrecaoModal.vue